// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"89b1dbe8","453":"4ad3a339"}[chunkId] + ".chunk.js";
};